import { makeAutoObservable, runInAction } from 'mobx';
import { request } from '@src/common';
import Local from '@/common/helper/local';
import navbarStore from '@/store/navbar';
import { HelperCore, HelpOther } from '@/common/helper';
import homeStore from '@/pages/home/store';

const cacheKey = 'MODEL_CHOICE_IDS';
const RETRY_COUNT = 3;

class Store {
  list = [];
  // 组织私有模型
  orgList = []
  // 通用模型
  commonList = []
  frontIds = [];
  agentList = [];
  curId = null;
  currentModel = null;
  index = 0;
  getting = false;
  loaded = false;
  /**
   * 激活的tab
   * @property {(9999 | 10)} activeTab
   */
  activeTab = 9999;

  tabList = [
    {
      id: 9999,
      name: '组织私有模型',
      type: 'org',
    },
    {
      id: 10,
      name: '通用模型',
      type: 'official',
    },
  ];

  get tabs() {
    return this.tabList;
  }

  constructor() {
    makeAutoObservable(this);
  }

  switchTab = tab => {
    this.activeTab = tab;
    if (tab === 9999) {
      this.curId = this.list[0].id;
      this.currentModel = this.list[0];
      this.pushFrontId(this.list[0].id);
    } else if (tab === 10) {
      const officialList = this.list.filter(item => item.model_type !== 9999);
      this.curId = officialList[0]?.id;
      this.currentModel = officialList[0];
      if (officialList[0]?.id) {
        this.pushFrontId(officialList[0].id);
      }
    }
  };

  switchCurId = id => {
    this.curId = id;
    this.currentModel = this.list.find(model => model.id === id);
  };

  handleMove = (e, isAdd, item) => {
    e.stopPropagation();

    request
      .post(
        '/user/model/add',
        {
          id: item.id,
          enable: isAdd,
          firm_id: item.firm_id,
          update_time: Date.now(),
          model_type: item.model_type,
        },
        {
          dataIsJson: true,
        }
      )
      .then(() => {
        HelpOther.toast((isAdd ? '加入' : '移出') + '成功');
        homeStore.updateModelList();
      });
  };

  pushFrontId = id => {
    this.frontIds = HelperCore.removeRepeatArray([id, ...this.frontIds]).slice(0, 3);
  };

  updateCacheId = id => {
    const cacheArr = Local.getItem(cacheKey) || [];
    if (cacheArr.includes(id)) {
      cacheArr.forEach((_id, index) => {
        if (_id == id) {
          cacheArr.unshift(cacheArr.splice(index, 1)[0]);
        }
      });
    } else {
      cacheArr.unshift(id);
    }
    Local.setItem(cacheKey, cacheArr.slice(0, 5));
  };

  setFrontIds = () => {
    //始终将助手放在第一个
    this.updateCacheId(this.list[0].id);
    const ids = this.list.map(item => item.id);
    const cacheArr = Local.getItem(cacheKey) || [];
    const frontIds = [...cacheArr, ...ids];
    this.frontIds = HelperCore.removeRepeatArray(frontIds).slice(0, 3);
  };

  /**
   * 加载模型列表
   * 重要接口，加重试
   * 加载失败时会话不可用
   */
  getList = (retry_count = 1) => {
    if (this.getting || this.loaded) {
      return;
    }
    this.getting = true;
    // 同时加载基础模型列表和企业模型列表
    return Promise.all([
      request.get('/assistant/sys/robot'),
      request.get('/robot/list', {
        params: {
          size: 10,
          scene: 'ent', // 企业场景
        },
      }),
    ])
      .then(([baseRes, orgRes]) => {
        const baseList = baseRes.data?.list || [];
        const orgList = orgRes.data?.list || [];
        // 处理企业模型数据，添加必要的标识
        const processedOrgList = orgList.map(item => ({
          ...item,
          model_type: 9999, // 标记为组织私有模型类型
          is_org_model: true, // 添加标识
        }));
        // 合并基础模型和企业模型
        const combinedList = [...processedOrgList, ...baseList];
        runInAction(() => {
          this.list = combinedList;
          this.orgList = processedOrgList
          this.commonList = baseList
          navbarStore.setChatModels(this.list);
          if (!this.curId) {
            const urlObj = new URL(window.location.href);
            if (urlObj.searchParams.get('kbId')) {
              // 自动选中第一个有知识库联通性的model
              const canRagCallModel = this.orgList.find(model => model.rag_recall == 1)
              this.curId = canRagCallModel ? canRagCallModel.id : this.list[0].id
              this.currentModel = canRagCallModel ? canRagCallModel : this.list[0];
              this.setFrontIds();
              this.pushFrontId(this.curId)
            } else {
              this.curId = this.list[0].id;
              this.currentModel = this.list[0];
              this.setFrontIds();
            }
          }
          this.getting = false;
          this.loaded = true;
        });
      })
      .catch(() => {
        if (retry_count < RETRY_COUNT) {
          runInAction(() => {
            this.getting = false;
          });
          this.getList(retry_count + 1);
        } else {
          runInAction(() => {
            this.getting = false;
            this.loaded = true;
          });
        }
      });
  };

  /**
   * 加载智能体列表
   */
  loadAgentList = () => {
    request
      .post('/agent/discovery', {
        channel_identifier: 'nami_home',
        page_size: 20,
      })
      .then(res => {
        const { data } = res;
        const { data: list } = data;
        runInAction(() => {
          this.agentList = list.map(item => {
            return {
              ...item,
              ...{
                id: item.id,
                title: item.name,
                description: item.description,
                icon: item.icon,
              },
            };
          });
        });
      });
  };
}

const modelChoiceStore = new Store();
export default modelChoiceStore;
